import { render, staticRenderFns } from "./KhachDuLichForm.vue?vue&type=template&id=57f21fb6"
import script from "./KhachDuLichForm.vue?vue&type=script&lang=js"
export * from "./KhachDuLichForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports